import Button from 'components/Button/Button'
import { Input } from 'components/Input'
import Table from 'components/Table'
import React, { useEffect, useState } from 'react'
import { ProgramListProps } from './ProgramList.props'
import {
  ProgramListContainer,
  ProgramListHeaderContainer,
  ProgramSwitcher,
  ProgramSwitcherContainer,
  ProgramSwitcherLabel,
} from './ProgramList.styled'
import ProgramListItem from './ProgramListItem'
import { AiOutlinePlus } from 'react-icons/ai'
import Switcher from 'components/Switcher/Switcher'
import { useAppDispatch, useAppState } from 'store'
import { programActions } from 'store/slices/programs'
import { Program } from 'models/program.model'

const PROGRAMS_HEADER: string[] = ['Name', 'Options']
const ProgramList = ({
  onEdit,
  onProgramType,
  onSearch,
  onCurrentProgram,
}: ProgramListProps) => {
  const [currentProgram, setCurrentProgram] = useState<boolean>(false);
  const [programsList, setProgramsList] = useState<Program[]>([])

  const dispatch = useAppDispatch()
  const { totalPrograms, currentPage, programs, programStatus } = useAppState(
    state => state.programs
  )
  const handlePage = (newPage: number) => {
    dispatch(programActions.setCurrentPage(newPage))
  }

  useEffect(() => {
    onCurrentProgram(currentProgram)
  }, [currentProgram])

  useEffect(() => {
    if(programs){
      const newList: Program[] = [];
      setProgramsList(list => newList.concat(programs))
    }
  }, [programs])

  return (
    <ProgramListContainer>
      <ProgramListHeaderContainer>
        <Input
          label={'Search'}
          placeholder="Program Name"
          required
          onChange={evt => onSearch(evt.target.value)}
        />
        <ProgramSwitcherContainer>
          <ProgramSwitcherLabel>Current Programs</ProgramSwitcherLabel>
          <ProgramSwitcher>
            <Switcher
              defaultChecked={currentProgram}
              onChange={() => setCurrentProgram(!currentProgram)}
            />
          </ProgramSwitcher>
        </ProgramSwitcherContainer>
        <Button
          text="Create"
          variant="primary"
          preset="filled"
          size={'small'}
          RightIcon={AiOutlinePlus}
          onClick={() => onProgramType('create')}
        />
      </ProgramListHeaderContainer>
      <Table
        header={PROGRAMS_HEADER}
        pagination
        totalCount={totalPrograms}
        currentPage={currentPage}
        onChangePage={handlePage}
        loading={programStatus == 'loading'}>
        {programStatus !== 'loading' &&
          programsList &&
          programsList.length > 0 &&
          programsList.map(program => (
            <ProgramListItem
              onEdit={id => {
                onProgramType('edit')
                onEdit(id)
              }}
              program={program}
              key={program.id}
            />
          ))}
      </Table>
    </ProgramListContainer>
  )
}

export default ProgramList
